import { Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { formatDateTime, isColorDark, obtenerFechaHoraSQL, textoMayusculas } from '../../../../utils/utils';
import { actualizarTarea, eliminarTarea, updateTarea } from '../../../../services/apis';
import InfoIcon from '@mui/icons-material/Info';
import { FormEditarTarea } from '../FormEditarTareay';
import { TareaDialogSA } from './TareaDialogSA';



export const TareaSaCard = ({ tarea, opciones, estados, cargarTareas, opclientes, opTrabajadores }) => {

    const [tareaInfo, setTareaInfo] = useState(tarea);
    const [tareaEditar, setTareaEditar] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [backgroundCard, setBackgroundCArd] = useState(estados.find(estado => estado.id === tarea.id_estado).color);
    const [textColor, setTextColor] = useState(isColorDark(tareaInfo.estado_color) ? '#FFFFFF' : '#000000');

    //cambiar dinamicamente el color del fondo de la tarjeta
    useEffect(() => {
        setTextColor(isColorDark(estados.find(estado => estado.id == tareaInfo.id_estado).color) ? '#FFFFFF' : '#000000');
        setBackgroundCArd(estados.find(estado => estado.id == tareaInfo.id_estado).color);
    }, [tareaInfo.id_estado]);

    useEffect(() => {
        setTareaInfo(tarea);
    }, [tarea])

    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                handleOnChange({ id_estado: 1 })
                // Lógica para la opción 1
                break;
            case 2:
                handleOnChange({ id_estado: 2 })
                // Lógica para la opción 2
                break;
            case 3:
                handleOnChange({ id_estado: 3 })

                // Lógica para la opción 3
                break;
            case 4:
                handleOnChange({ id_estado: 4 })
                // Lógica para la opción 4
                break;
            case 50:
                setTareaEditar(true);
                break;
            case 51:
                eliminarTareaF(tarea.id);
                break;
            case 90:
                // Lógica para la opción 4
                break;
            default:
                console.log("Lógica para una opción desconocida");
                // Lógica para una opción desconocida
                break;
        }
    }


    const handleOnChange = (data) => {
        // Crear una copia del objeto tarea
        let temp = { ...tareaInfo };
        // Obtener la clave y el valor del objeto data
        const [key, value] = Object.entries(data)[0];

        // Verificar si la clave existe en el objeto tarea
        if (temp.hasOwnProperty(key)) {
            // Cambiar el valor del elemento que coincide
            temp[key] = value;
        }
        // Actualizar el estado de tarea con el nuevo objeto modificado
        // Suponiendo que estás usando useState para manejar el estado de tarea
        // setTareaInfo(temp); si se deja activo da la falsa ilusion de que laggea
        actualizarTareaEstado(temp);
        // Para fines de depuración
    };

    const actualizarTareaEstado = (data) => {
        let temp = { ...data };
        temp.fechaActual = obtenerFechaHoraSQL();
        actualizarTarea(temp).then(() => {
            cargarTareas(); // Se ejecuta después de que actualizarTarea se completa
        })
    }

    const eliminarTareaF = async (id) => {
        try {
            const response = await eliminarTarea(id)
            if (response.success == true) {
                cargarTareas();
            }
        }
        catch (error) {
            console.error("Error al eliminar la tarea:", error);

        }
    }

    return (
        <Grid
            container
            direction="column"
            justifyContent="start"
            alignItems="center"
            xs={12}
            gap={1}
            fontWeight={500}
            padding={2}
            style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor,
                minHeight: '40vh',
                maxHeight: '100vh',
            }}
            className="tarea-card-sa fade-in2"
        >

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="start"
                xs={12}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="start"
                    xs={11.5}
                    sx={{
                        // backgroundColor: 'red',
                        minHeight: '14vh',
                        maxHeight: '20vh',
                    }}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                    >
                        <Typography variant="body1">
                            Tarea: {tareaInfo.id}
                        </Typography>

                        <Grid item xs={1.5} onClick={() => setOpen(true)} className='pointer'>
                            <Badge badgeContent={tareaInfo.comentarios.total_comentarios} color="primary">
                                <InfoIcon sx={{ fontSize: 30, marginBottom: 2 }} />
                            </Badge>
                        </Grid>
                    </Grid>


                    <Grid item xs={12} textAlign={'left'}>
                        <Typography variant="h5"
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 1, // Limita el número de líneas
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                            {textoMayusculas(tareaInfo.cliente)}
                        </Typography>
                    </Grid>


                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        gap={1}
                    >
                        <Grid item xs={6} style={{
                            textAlign: 'left',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                        }} >
                            <Typography variant="caption">
                                {tareaInfo.correo}
                            </Typography>
                        </Grid>

                        <Grid item xs={5.5} style={{ textAlign: 'right' }}>
                            <Typography variant="caption">
                                {formatDateTime(tareaInfo.fecha)}
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* {((tareaInfo.horas != undefined) && (tareaInfo.minutos != undefined)) && (
                        <Grid item xs={12} style={{ textAlign: 'left' }}>
                            <Typography variant="subtitle1">
                                Horas empleadas: {tareaInfo.horas + ":" + tareaInfo.minutos + " HH:mm"}
                            </Typography>
                        </Grid>
                    )} */}


                </Grid>


            </Grid>

            {/* <div className="separador"></div> */}

            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="start"
                xs={11.5}
                sx={{
                    // backgroundColor: 'red',
                    minHeight: '10vh', // Ajusta este valor a la altura fija que deseas
                    maxHeight: '50vh',
                }}
            >
                <Typography variant="h6" gutterBottom
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2, // Limita el número de líneas
                        WebkitBoxOrient: 'vertical',
                        fontWeight: 750,
                        minHeight: '7vh',
                        maxHeight: '15vh',
                        // backgroundColor: 'red'
                    }} textAlign={'left'}
                >
                    {tareaInfo.asunto}
                </Typography>

                <Grid
                    container
                    xs={12}
                    justifyContent="start"
                    alignItems="start"
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2, // Limita el número de líneas
                        WebkitBoxOrient: 'vertical',
                        minHeight: '4vh', // Ajusta este valor a la altura fija que deseas
                        maxHeight: '10vh',
                    }}
                >

                    <Typography variant="body2" gutterBottom textAlign={'left'}>
                        {tareaInfo.descripcion}
                    </Typography>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="start"
                xs={11.5}
                sx={{
                    // backgroundColor: 'red',
                    minHeight: '6vh',
                    maxHeight: '40vh',
                }}
            >

                {tareaInfo.trabajadores.length > 0 && (
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        xs={12}
                    >
                        {tareaInfo.trabajadores.length > 0 && (
                            <Grid container xs={12} direction="row" justifyContent="start" alignItems="start">
                                <Grid container xs={12} direction="row" justifyContent="start" alignItems="start" style={{ marginBottom: '-0.5em' }}>
                                    <Typography variant="subtitle2" gutterBottom>
                                        Asignado a:&nbsp;
                                        {(tareaInfo.trabajadores.slice(0, 3)).map((trabajador, index) => (
                                            <span>{textoMayusculas(trabajador.label)}&nbsp;</span>
                                        ))}
                                    </Typography>
                                </Grid>
                                <>
                                    {tareaInfo.trabajadores.length > 3 && (
                                        <Typography variant="caption" gutterBottom sx={{ fontWeight: 600 }}>
                                            y mas...
                                        </Typography>
                                    )}
                                </>
                            </Grid>
                        )}
                        {/* {tareaInfo.trabajadores.length == 0 && (
                        <Grid container xs={12} direction="column" justifyContent="start" alignItems="start">
                            <Typography variant="subtitle1" gutterBottom>
                                Asignado a: &nbsp;
                            </Typography>
                            <Typography variant="caption" gutterBottom >
                                Sin Asignar
                            </Typography>
                        </Grid>

                    )} */}


                    </Grid>
                )}

                {tareaInfo.usuarios_con_tiempo.length > 0 && (
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        xs={12}
                    >
                        {tareaInfo.usuarios_con_tiempo.length > 0 && (
                            <Grid container xs={12} justifyContent="start" alignItems="start">
                                <Typography variant="subtitle2" gutterBottom style={{ marginBottom: '-0.2em' }} >
                                    En curso por:&nbsp;
                                    {(tareaInfo.usuarios_con_tiempo.slice(0, 3)).map((trabajador, index) => (
                                        <span>{textoMayusculas(trabajador.label)}&nbsp;</span>
                                    ))}
                                </Typography>
                                <>
                                    {tareaInfo.usuarios_con_tiempo.length > 3 && (
                                        <Typography variant="caption" gutterBottom sx={{ fontWeight: 600 }}>
                                            y mas...
                                        </Typography>
                                    )}
                                </>
                            </Grid>
                        )}
                        {/* {tareaInfo.usuarios_con_tiempo.length === 0 && (
                        <Grid container xs={12} justifyContent="start" alignItems="end" >
                            <Typography variant="subtitle1" gutterBottom textAlign={'right'}>
                                En curso por:&nbsp;
                            </Typography>
                            <Typography variant="caption" gutterBottom textAlign={'right'}>
                                Sin trabajadores en curso
                            </Typography>
                        </Grid>
                    )} */}

                    </Grid>
                )}

                <Typography variant='caption' sx={{ mt: 1 }}>
                    <strong>Creado por: </strong>{tareaInfo.creador}
                </Typography>

            </Grid>



            {/* //desplegable */}
            {/* {
                tareaEditar == true && (
                    <FormEditarTarea open={tareaEditar} setOpen={setTareaEditar} cargarTareas={cargarTareas} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo}
                        opclientes={opclientes} opTrabajadores={opTrabajadores} trabajadores={tarea.trabajadores} />
                )
            }
            {
                tareaEditar == true && (
                    <FormEditarTarea open={tareaEditar} setOpen={setTareaEditar} cargarTareas={cargarTareas} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo}
                        opclientes={opclientes} opTrabajadores={opTrabajadores} trabajadores={tarea.trabajadores} />
                )
            } */}
            {open === true && (


                <Grid container xs={12} justifyContent={'space-between'}>
                    <TareaDialogSA open={open} setOpen={setOpen} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo} opciones={opciones} handleEvent={handleEvent} backgroundCard={backgroundCard} textColor={textColor} />
                </Grid >
            )}
        </Grid >

    )
}
